class productLoyalty extends HTMLElement {
  constructor() {
    super();
    this.defaultMultiplier = this.dataset.defaultMultiplier || 1;
    this.multiplierValue = this.defaultMultiplier;
    this.launcherButton = this.querySelector(".product-loyalty__launcher");
    this.smileLauncherHider = document.querySelector(".smile-launcher-hider");
    this.initOnLauncherClick();
  }
  connectedCallback() {
    this.mainProduct = this.closest("main-product");
    this.price = this.dataset.price;
    this.pointsContainer = this.querySelector("[data-points]");
    this.load();
  }

  initOnLauncherClick() {
    if (!this.launcherButton || !this.smileLauncherHider) {
      return;
    }
    // This is a link that adds to the URL anchor, no need to prevent default.
    // Remove css style hiding the launcher when this button is clicked
    this.launcherButton.addEventListener("click", () => {
      this.smileLauncherHider.innerHTML = "";
    });
  }

  async load() {
    this.mainProduct.addEventListener("productPriceChange", (evt) => {
      this.price = evt.detail;
      this.changePoints();
    });
    try {
      this.vipMultiplier = JSON.parse(this.dataset.vip);
    } catch (e) {
      this.vipMultiplier = [];
    }
    if (this.dataset.loggedIn === "true") {
      await this.checkSmileLoad();
      const vipMultiplier = this.vipMultiplier.find((v) =>
        v.includes(this.customerTier)
      );
      if (vipMultiplier) {
        this.multiplierValue =
          vipMultiplier.split(":")[1] || this.defaultMultiplier;
      }
      this.changePoints();
    }
  }

  changePoints() {
    const points = Math.ceil(
      (this.multiplierValue * this.price) / theme.cart.currency_with_vat / 100
    );
    this.classList.remove("loading");
    this.pointsContainer.innerText = points;
  }
  async checkSmileLoad() {
    let timeoutInMs = 500;
    let currentTimeoutInMs = 0;
    while (!window.Smile || !window.Smile.customer) {
      await timeout(timeoutInMs);
      currentTimeoutInMs += timeoutInMs;
      if (currentTimeoutInMs >= timeoutInMs * 20) {
        return Promise.resolve();
      }
    }
    if (window.Smile.customer)
      this.customerTier = window.Smile.customer.vip_tier_id;
    return Promise.resolve();
  }
}
customElements.define("product-loyalty", productLoyalty);
